import { lazy } from "react";

const DocumentationPage = lazy(() => import("./DocumentationPage"));

const documentationRoutes = [
  {
    path: "/documentation/:routeId",
    component: DocumentationPage
  }
];

export default documentationRoutes;
